import * as moment from 'moment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DateConvertor {

  addGMTOffset(somedate) {
    let date = somedate._d
    if (!date) {
      date = somedate;
    }
    var datewithoffset = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return datewithoffset;
  }


  moment(dateString) {
    var dateObj = new Date(dateString);
    var momentObj = moment(dateObj);
    var momentString = momentObj.format('MM/DD/YYYY');
    return momentString;
  }

  momentChange(dateString) {
    var dateObj = new Date(dateString);
    var momentObj = moment(dateObj);
    var momentString = momentObj.format('MM-DD-YYYY');
    return momentString;
  }

}

